import { inject, Injectable } from '@angular/core';

import { HttpCoreService } from '@dataclouder/ngx-core';
import { KnowledgeProgressTracker, KnowledgeUserState } from '../models/knowledge.models';
import { get } from 'lodash';
import { KnowledgeDbService } from './state-knowledge-db.service';
import { KnowledgeStateTablesService } from './state-knowledge-cat-db.service'; // Added for categorized DB

const Endpoints = {
  SaveProgress: 'api/knowledge/progress',
  GetProgressTracker: 'api/knowledge/progress-tracker',
  GetKnowledgeGraph: 'api/knowledge/knowledge-state',
  GetKnowledgePath: 'api/knowledge/knowledge-state',
};

@Injectable({
  providedIn: 'root',
})
// This is used by the graphs, i think i dont need it.
export class KnowledgeTrackerService {
  public knowledgeState: Record<string, KnowledgeUserState> = {};

  private httpCoreService = inject(HttpCoreService);
  private knowledgeDbService = inject(KnowledgeDbService);
  private knowledgeStateTablesService = inject(KnowledgeStateTablesService); // Added for categorized DB

  private async loadState() {
    const data = await this.knowledgeDbService.getAllKnowledgeUserStateAsObject();
    this.knowledgeState = data;
  }

  constructor() {
    this.loadState();
  }

  async saveProgress<T>(progressTrack: KnowledgeProgressTracker, tableName?: T) {
    const response = await this.httpCoreService.post(Endpoints.SaveProgress, [progressTrack]);
    if (response) {
      this.knowledgeState[progressTrack.concept] = response; // Update in-memory state

      let dbResult;
      if (tableName) {
        dbResult = await this.knowledgeStateTablesService.addOrUpdateKnowledgeUserState(tableName, response);
      } else {
        dbResult = await this.knowledgeDbService.addOrUpdateKnowledgeUserState(response);
      }
      console.log('DB save result:', dbResult);
    }
    return response;
  }

  async getProgressTracker() {
    const response = await this.httpCoreService.get(Endpoints.GetProgressTracker);
    return response;
  }

  async getKnowledgeByPath(path: string, extractPath?: string): Promise<Record<string, KnowledgeUserState>> {
    const response = await this.httpCoreService.get(`${Endpoints.GetKnowledgePath}/${path}`);
    if (extractPath) {
      return get(response, extractPath);
    }
    return response;
  }
}
